import useHttpQuery from 'data/firestore/useHttpQuery';
import useDebouncedValue from 'hooks/useDebouncedValue';
import { PAGE_SIZE } from '../../../constants';
import buildQueryPath from './helpers/buildQueryPath';
import buildQueryKey from './helpers/buildQueryKey';
import { SearchOpportunitiesQuery, SearchOpportunitiesResponse } from './types';

const useSearchOpportunities = ({
    agentId = '',
    searchQuery,
    createdAt,
    owner,
    score,
    amount,
    tags,
    stageIds,
    pipelineId,
    sortBy = 'updatedAt',
    sortOrder = 'asc',
    pageSize = PAGE_SIZE,
    page = 1,
    queryOptions = { enabled: true },
}: SearchOpportunitiesQuery) => {
    const debouncedQuery = useDebouncedValue(searchQuery);

    return useHttpQuery<SearchOpportunitiesResponse>({
        key: buildQueryKey({
            agentId,
            searchQuery: debouncedQuery,
            createdAt,
            owner,
            score,
            amount,
            stageIds,
            pipelineId,
            tags,
            sortBy,
            sortOrder,
            pageSize,
            page,
        }),
        pathname: buildQueryPath({
            basePath: `/agents/${agentId}/opportunities/search`,
            filters: {
                searchQuery: debouncedQuery,
                createdAt,
                owner,
                score,
                stageIds,
                pipelineId,
                amount,
                tags,
                sortBy,
                sortOrder,
                pageSize,
                page,
            },
        }),
        queryOptions: {
            ...queryOptions,
            enabled: queryOptions.enabled && !!agentId,
        },
    });
};

export default useSearchOpportunities;
